<template>
  <div class="property-summary">
    <div
      class="d-flex flex-wrap"
      style="gap: 4px 16px"
    >
      <span v-if="propertyTypeLabel"><strong>Tipo:</strong> {{ propertyTypeLabel }}</span>
      <span v-if="data.address"><strong>Endereço:</strong> {{ data.address }}</span>
      <span v-if="data.reference"><strong>Referência:</strong> {{ data.reference }}</span>
      <span v-if="data.description"><strong>Descrição:</strong> {{ data.description }}</span>
    </div>
    <div
      v-if="data.observation"
      class="text-muted small mt-1"
    >
      {{ data.observation }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertySummary',
  props: {
    data: { type: Object, default: () => ({}) },
  },
  computed: {
    propertyTypeLabel() {
      const map = {
        casa: 'Casa',
        apartamento: 'Apartamento',
        comercio: 'Comércio',
        terreno: 'Terreno',
        outro: 'Outro',
      }
      return map[this.data.property_type] || this.data.property_type || ''
    },
  },
}
</script>
